export type Feature = {
  icon: string;
  title: string;
  desc: string;
  tag: string;
};

export const features: Feature[] = [
  {
    icon: "ri-heart-3-line",
    title: "缘分匹配",
    desc: "结合城市、兴趣与相处节奏，把更契合的单身会员推荐到你面前，减少无效寒暄。",
    tag: "婚恋",
  },
  {
    icon: "ri-group-line",
    title: "单身群",
    desc: "按城市与兴趣划分的群组，先聊共同话题再决定是否私聊，慢热的人也不会觉得尴尬。",
    tag: "社交",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "同城交友圈",
    desc: "浏览同一座城市的动态与活动，认识住在附近的邻居，让线上线下自然衔接。",
    tag: "同城",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "主题聊天室",
    desc: "深夜书房、周末露营、职场茶话会……想聊就进，随时有人接着你的话头。",
    tag: "聊天室",
  },
  {
    icon: "ri-calendar-check-line",
    title: "活动约伴",
    desc: "拼桌吃饭、看展、citywalk，把线上的好感变成一次真实而轻松的相处。",
    tag: "活动",
  },
  {
    icon: "ri-shield-check-line",
    title: "实名与安全",
    desc: "隐私设置、举报通道与见面提醒彼此配合，让相遇既有温度也有分寸。",
    tag: "安全",
  },
];

export type City = {
  name: string;
  active: string;
  groups: string;
  vibe: string;
};

export const cities: City[] = [
  { name: "北京", active: "12,600+", groups: "38 个单身群", vibe: "文化展览与骑行路线丰富，适合喜欢深度交流的人。" },
  { name: "上海", active: "14,200+", groups: "42 个单身群", vibe: "咖啡馆与市集密集，轻松约会场景多，节奏偏精致。" },
  { name: "广州", active: "9,800+", groups: "31 个单身群", vibe: "老城美食与夜生活并存，适合边吃边聊的相处方式。" },
  { name: "深圳", active: "11,300+", groups: "36 个单身群", vibe: "年轻人口多、活动更新快，周末徒步与海边聚会热门。" },
  { name: "成都", active: "10,500+", groups: "34 个单身群", vibe: "茶馆、livehouse 与露营氛围浓，慢节奏交友的代表城市。" },
  { name: "杭州", active: "8,900+", groups: "29 个单身群", vibe: "西湖周边散步与骑行活动多，适合文艺向的破冰方式。" },
  { name: "武汉", active: "7,600+", groups: "26 个单身群", vibe: "高校多、年轻群体活跃，读书会与桌游局常有人组。" },
  { name: "西安", active: "6,400+", groups: "23 个单身群", vibe: "历史街区适合边走边聊，摄影与美食同好集中。" },
];

export type Group = {
  name: string;
  city: string;
  members: string;
  category: string;
  desc: string;
};

export const groupCategories: string[] = ["全部", "城市群", "兴趣群", "年龄群", "话题群"];

export const groups: Group[] = [
  { name: "北京·周末城市漫游", city: "北京", members: "486 人", category: "城市群", desc: "每周约一条胡同或公园路线，边走边认识同城的朋友。" },
  { name: "上海·咖啡馆读书会", city: "上海", members: "352 人", category: "兴趣群", desc: "一月一本书，线下咖啡馆分享，聊书也聊生活。" },
  { name: "深圳·海边徒步搭子", city: "深圳", members: "410 人", category: "兴趣群", desc: "大鹏半岛徒步与日落露营，适合爱运动的单身会员。" },
  { name: "成都·茶馆慢聊局", city: "成都", members: "298 人", category: "城市群", desc: "周末下午一壶茶，不赶时间地认识彼此。" },
  { name: "90 后职场单身群", city: "全国", members: "1,240 人", category: "年龄群", desc: "同处职场阶段的伙伴，聊工作也聊相亲与生活规划。" },
  { name: "广州·深夜美食探员", city: "广州", members: "376 人", category: "兴趣群", desc: "组队扫街觅食，用一顿宵夜开启聊天。" },
  { name: "认真恋爱·脱单互助", city: "全国", members: "864 人", category: "话题群", desc: "分享沟通心得与约会体验，帮彼此把关系推进下去。" },
  { name: "杭州·骑行与摄影", city: "杭州", members: "312 人", category: "兴趣群", desc: "沿湖骑行、随手拍片，边拍边聊的轻松聚会。" },
  { name: "西安·古城摄影同好", city: "西安", members: "245 人", category: "兴趣群", desc: "城墙与老巷取景，适合喜欢记录生活的人。" },
];

export type ChatRoom = {
  name: string;
  topic: string;
  online: string;
  desc: string;
  mood: string;
};

export const chatRooms: ChatRoom[] = [
  { name: "深夜书房", topic: "读书 / 电影 / 心事", online: "128 人在线", desc: "安静的话题房间，适合想认真聊聊近况的人。", mood: "安静" },
  { name: "周末露营团", topic: "露营 / 装备 / 出行", online: "76 人在线", desc: "约装备、约营地、约同行，户外同好的聚集地。", mood: "热闹" },
  { name: "烘焙厨房", topic: "料理 / 探店 / 食谱", online: "54 人在线", desc: "晒作品、交换食谱，也约一起下厨的搭子。", mood: "温暖" },
  { name: "职场茶话会", topic: "工作 / 副业 / 成长", online: "93 人在线", desc: "吐槽职场、聊行业变化，认识同频的都市单身。", mood: "务实" },
  { name: "观影同好", topic: "院线 / 剧集 / 影评", online: "61 人在线", desc: "每周一部片单，聊完还能约线下观影。", mood: "文艺" },
  { name: "健身打卡", topic: "健身 / 跑步 / 互助", online: "88 人在线", desc: "互相监督打卡，也约晨跑和周末运动局。", mood: "活力" },
];

export type Step = {
  no: string;
  title: string;
  desc: string;
};

export const matchSteps: Step[] = [
  { no: "01", title: "完善个人资料", desc: "填写城市、兴趣与相处偏好，系统据此建立你的匹配画像。" },
  { no: "02", title: "浏览缘分推荐", desc: "每日更新与你契合的会员，可收藏也可跳过，主动权在你手里。" },
  { no: "03", title: "轻松破冰", desc: "从共同兴趣或群组话题入手开启对话，聊天室提供自然的开场。" },
  { no: "04", title: "线下自然见面", desc: "在公共同城活动中把好感落地，从一次轻松的相处开始关系。" },
];

export type Story = {
  names: string;
  city: string;
  quote: string;
  highlight: string;
};

export const stories: Story[] = [
  {
    names: "阿哲 & 小雨",
    city: "上海",
    highlight: "在读书会群里认识",
    quote: "本来只是想在群里找人聊书，结果聊着聊着发现住的只隔两条街，现在已经一起走过一年多。",
  },
  {
    names: "林小姐",
    city: "成都",
    highlight: "通过缘分匹配牵线",
    quote: "推荐的人选比我想象中靠谱，兴趣标签很细，第一次线下约在茶馆，完全不尴尬。",
  },
  {
    names: "陈先生",
    city: "深圳",
    highlight: "从徒步搭子到恋人",
    quote: "海边徒步那次认识了她，同样喜欢运动的人相处起来很省力，感谢那个群。",
  },
];

export type SafetyTip = {
  icon: string;
  title: string;
  desc: string;
};

export const safetyTips: SafetyTip[] = [
  { icon: "ri-eye-off-line", title: "谨慎分享隐私", desc: "住址、具体单位、证件与财务信息不要在早期聊天中透露。" },
  { icon: "ri-store-2-line", title: "选择公共场合见面", desc: "首次见面尽量在商场、咖啡馆等人多的地方，避免私人空间。" },
  { icon: "ri-user-shared-line", title: "告知亲友行程", desc: "把见面时间地点告诉一位朋友，并保持手机可联系。" },
  { icon: "ri-emotion-normal-line", title: "保持理性的节奏", desc: "真诚需要时间，警惕催促转账、投资或借钱的请求。" },
  { icon: "ri-alarm-warning-line", title: "及时举报异常", desc: "遇到骚扰、虚假资料或诱导行为，请立即举报并拉黑。" },
  { icon: "ri-roadster-line", title: "独立安排交通", desc: "自行前往与返回，方便在任何时候结束这次见面。" },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: "爱情岛是免费使用的吗？",
    a: "浏览同城交友圈、加入部分单身群与进入公开聊天室可以免费体验；更深入的缘分匹配与私聊功能会随版本调整，具体以页面内的说明为准。",
  },
  {
    q: "缘分匹配是怎么推荐人的？",
    a: "系统会参考你填写的城市、年龄段、兴趣爱好与相处偏好，结合活跃度为你排序推荐。它只是帮你缩小范围，最终是否聊天与见面仍由你决定。",
  },
  {
    q: "怎么加入感兴趣的单身群？",
    a: "在「单身群」分区按城市、兴趣、年龄或话题筛选，找到合适的群后进入群介绍即可了解加入方式，建议先从你熟悉的话题群开始。",
  },
  {
    q: "聊天室有发言规则吗？",
    a: "有。聊天室禁止广告、骚扰、虚假身份与人身攻击，成员的举报会由社区志愿者处理。保持礼貌与真诚，是房间里最被看重的品质。",
  },
  {
    q: "同城交友功能覆盖哪些城市？",
    a: "目前重点覆盖北京、上海、广州、深圳、成都、杭州、武汉、西安等城市，其余城市会随成员增长陆续开放，你也可以加入全国性的兴趣群。",
  },
  {
    q: "第一次线下见面要注意什么？",
    a: "尽量选择白天的公共场所，自行安排交通并把行程告诉亲友。见面过程中如感到不适，随时可以结束，安全永远排在第一位。",
  },
];